import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/Common/ErrorBoundary';
import { AdminProvider } from './contexts/AdminContext';
import { LocaleProvider } from './contexts/LocaleContext';
import Snowfall from 'react-snowfall';
import './App.css';

// Code splitting - lazy load components
const AdminLogin = lazy(() => import('./components/Admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./components/Admin/AdminDashboard'));
const ParticipantSignup = lazy(() => import('./components/Participant/ParticipantSignup'));
const ParticipantQuiz = lazy(() => import('./components/Participant/ParticipantQuiz'));

// Loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    color: '#ffd700',
    fontSize: '1.5rem'
  }}>
    <div>Loading...</div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <LocaleProvider>
        <AdminProvider>
          <Router>
          <div className="App">
            <Snowfall
              snowflakeCount={50}
              style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: 1000,
                pointerEvents: 'none',
              }}
            />
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/quiz/:sessionCode" element={<ParticipantSignup />} />
                <Route path="/quiz/:sessionCode/play/:participantId" element={<ParticipantQuiz />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
        </AdminProvider>
      </LocaleProvider>
    </ErrorBoundary>
  );
}

export default App;

